import { BatchCollectConsignment } from 'types';
import { Text } from 'components';
import { FontSize } from 'commons';
import * as S from './styles';

interface ConsignmentReceiptProps {
  consignment: BatchCollectConsignment;
}

export function ConsignmentReceipt({
  consignment,
}: ConsignmentReceiptProps): JSX.Element {
  const { code, quantity } = consignment;

  return (
    <S.Consignment>
      <Text size={FontSize.font14}>{code}</Text>

      <Text size={FontSize.font14}>
        Qtd: {quantity} {quantity > 1 ? 'itens' : 'item'}
      </Text>
    </S.Consignment>
  );
}
